import { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { history } from '../../helpers/history';
import { commonClass } from '../../helpers/commonClass';
class HowToPlay extends Component {
	constructor(props) {
		super(props);
	}
	render() {
		const { t } = this.props;
		return (
			<>
				<h2 className="headding1">{t('lblHowToPlay')} </h2> <h1 className="headding1">{this.props.ispage == false && commonClass.IDWiseGameName(this.props.lottoType)}</h1> 
				<div class={`howToPlay ${this.props.ispage == true ? "lto-1-bg-gradiant" : ""}`}>
					<div class={`howToPlayLi ${this.props.ispage == true ? "howToPlayLi2" : ""}`} >
						<img src={`./assets/img/icons/${this.props.ispage == true ? 'htp-1-w.png' : 'htp-1.png'}`} />
						<span>{t('lblstep')}-1</span>
						<p dangerouslySetInnerHTML={{ __html: t(`lblHowToPlayRegOrLog`) }}></p>
					</div>
					<div class={`howToPlayLi ${this.props.ispage == true ? "howToPlayLi2" : ""}`} >
						<img src={`./assets/img/icons/${this.props.ispage == true ? 'htp-2-w.png?v0.1' : 'htp-2.png'}`} />
						<span>{t('lblstep')}-2</span>
						<p dangerouslySetInnerHTML={{ __html: t(`lblCompltePurchaseWaterBottle`) }}></p >
					</div >
					<div class={`howToPlayLi ${this.props.ispage == true ? "howToPlayLi2" : ""}`} >
						<img src={`./assets/img/icons/${this.props.ispage == true ? 'htp-3-w.png' : 'htp-3.png'}`} />
						<span>{t('lblstep')}-3</span>
						<p dangerouslySetInnerHTML={{ __html: t(`lblHowToPlayParticipate`) }}></p>
					</div >
					<div class={`howToPlayLi ${this.props.ispage == true ? "howToPlayLi2" : ""}`} >
						<img src={`./assets/img/icons/${this.props.ispage == true ? 'htp-4-w.png' : 'htp-4.png'}`} />
						<span>{t('lblstep')}-4</span>
						<p dangerouslySetInnerHTML={{ __html: t(`lblHowToPlayFavNo`) }}></p >
					</div >
					<div class={`howToPlayLi ${this.props.ispage == true ? "howToPlayLi2" : ""}`} >
						<img src={`./assets/img/icons/${this.props.ispage == true ? 'htp-5-w.png' : 'htp-5.png'}`} />
						<span>{t('lblstep')}-5</span>
						<p dangerouslySetInnerHTML={{ __html: t(`lblHowToPlayLiveDraw`) }}></p >
					</div >
					{/* {this.props.ispage == false && <p onClick={() => { history.push('/HowtoPlay') }}><span className='howtoplaybtn'>{t('lblKnowMore')}</span></p>} */}
				</div >


				{
					this.props.ispage != false &&
					<div class="howToPlayVideoLotto">
						<ul>
							<li>
								<div><img src="./assets/img/icons/user-plus.png" /><span>{t('lblHowTosignup')}</span></div>
								<iframe
									width="100%"
									height="auto"
									title="YouTube video player"
									// frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
									className="rounded-md iframeborder"
									allowFullScreen
									src="https://www.youtube.com/embed/wAvK6w99j2w?si=ykKro0HfQ3Ghc-q2&rel=0"
								>
								</iframe>
							</li>

							<li>
								<div><img src="./assets/img/icons/wallet-y.png" /><span>{t('lblHowTopurchase')}</span></div>
								<iframe
									width="100%"
									height="auto"
									title="YouTube video player"
									// frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
									className="rounded-md iframeborder"
									allowFullScreen
									src="https://www.youtube.com/embed/Jt9ZBNdyaDM?si=oaQxcK2Yh-Q5M8V9&rel=0"
								// style={{border:"0px"}}
								>
								</iframe>
							</li>

							<li>
								<div><img src="./assets/img/icons/withdraw-y.png" /><span>{t('lblHowToWdraw')}</span></div>
								<iframe
									width="100%"
									height="auto"
									title="YouTube video player"
									// frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
									className="rounded-md iframeborder"
									allowFullScreen
									src="https://www.youtube.com/embed/bXIJgPE0Vjs?si=iSmibpGIvxo6bgzb&rel=0"
								// style={{border:"0px"}}
								>
								</iframe>
							</li >
						</ul>
					</div>

				}
			</>
		)
	}

}
export default withTranslation()(HowToPlay)

